import React from 'react';
import { css, cx } from '@linaria/atomic';
import { InlineLabel } from '../../layouts';
import { useRadioContext } from '../../providers';
import { Radio } from './radio.component';

const componentDivStyle1 = css`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  * {
    cursor: pointer;
  }
`;

const componentDivStyle2 = css`
  flex-direction: row-reverse;

  label {
    width: 100%;
  }
`;

type Props = {
  children: React.ReactNode;
  disabled?: boolean;
  value: string;
  trackingId?: string;
  className?: string;
};

export const RadioOption = React.memo(({ children, disabled, trackingId, value, className, ...rest }: Props) => {
  const { getOptionProps, labelPlacement } = useRadioContext();
  const optProps = getOptionProps(value);

  return (
    <div {...rest} className={cx(componentDivStyle1, labelPlacement === 'left' && componentDivStyle2, className)}>
      <Radio {...optProps} trackingId={trackingId} disabled={disabled} />
      <InlineLabel id={optProps.id} placement={labelPlacement}>
        {children}
      </InlineLabel>
    </div>
  );
});

RadioOption.displayName = 'RadioOption';
